import React, { Component } from "react";
import { LinearProgress } from "@material-ui/core";
import { Image, Tabs } from "react-bootstrap";
import { Card } from "react-bootstrap";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
import { Spinner, Table } from "react-bootstrap";
import TableAkreditasi from "./Widget/TableAkreditasi";
import { Widget1 } from "./Widget/Widget1";
import { Widget2 } from "./Widget/Widget2";
import { Widget3 } from "./Widget/Widget3";
class Profile1 extends Component {
  render() {
    let display1 = "";
    let display2 = "";
    if (this.props.displayData === false) {
      let data = this.props.dataProfile.data.profile;
      let doktor = <></>;
      let magister = <></>;
      let profesi = <></>;
      let sarjana = <></>;
      let sarjana_terapan = <></>;
      let diploma = <></>;
      if (data.jumlahmahasiswa.doktor !== undefined) {
        doktor = (
          <>
            <div className="col-md-4">
              <div className=" d-flex flex-column align-items-center justify-content-center pt-10 pb-10 bgi-size-cover bgi-no-repeat rounded-top">
                <h1
                  className=" font-weight-bolder"
                  style={{ color: "#354f7a", fontSize: "28px" }}
                >
                  {data.jumlahmahasiswa.doktor !== "null"
                    ? data.jumlahmahasiswa.doktor
                    : 0}
                </h1>
                <h5
                  className="  card-title font-weight-bolder"
                  style={{ color: "#354f7a" }}
                >
                  Doktor
                </h5>
              </div>
            </div>
          </>
        );
      } else {
        doktor = (
          <>
            <div className="col-md-4">
              <div className=" d-flex flex-column align-items-center justify-content-center pt-10 pb-10 bgi-size-cover bgi-no-repeat rounded-top">
                <h1
                  className=" font-weight-bolder"
                  style={{ color: "#354f7a", fontSize: "28px" }}
                >
                  0
                </h1>
                <h5
                  className="  card-title font-weight-bolder"
                  style={{ color: "#354f7a" }}
                >
                  <del>Doktor</del>
                </h5>
              </div>
            </div>
          </>
        );
      }
      if (
        data.jumlahmahasiswa.magister ||
        data.jumlahmahasiswa["magister terapan"] !== undefined
      ) {
        magister = (
          <>
            <div className="col-md-4">
              <div className=" d-flex flex-column align-items-center justify-content-center pt-10 pb-10 bgi-size-cover bgi-no-repeat rounded-top">
                <h1
                  className=" font-weight-bolder"
                  style={{ color: "#354f7a", fontSize: "28px" }}
                >
                  {data.jumlahmahasiswa.magister ||
                  data.jumlahmahasiswa["magister terapan"] !== undefined
                    ? data.jumlahmahasiswa.magister ||
                      data.jumlahmahasiswa["magister terapan"]
                    : 0}
                </h1>
                <h5
                  className="  card-title font-weight-bolder"
                  style={{ color: "#354f7a" }}
                >
                  Magister
                </h5>
              </div>
            </div>
          </>
        );
      } else {
        magister = (
          <>
            <div className="col-md-4">
              <div className=" d-flex flex-column align-items-center justify-content-center pt-10 pb-10 bgi-size-cover bgi-no-repeat rounded-top">
                <h1
                  className=" font-weight-bolder"
                  style={{ color: "#354f7a", fontSize: "28px" }}
                >
                  0
                </h1>
                <h5
                  className="  card-title font-weight-bolder"
                  style={{ color: "#354f7a" }}
                >
                  <del>Magister</del>
                </h5>
              </div>
            </div>
          </>
        );
      }
      if (data.jumlahmahasiswa.profesi !== undefined) {
        profesi = (
          <>
            <div className="col-md-4">
              <div className=" d-flex flex-column align-items-center justify-content-center pt-10 pb-10 bgi-size-cover bgi-no-repeat rounded-top">
                <h1
                  className=" font-weight-bolder"
                  style={{ color: "#354f7a", fontSize: "28px" }}
                >
                  {data.jumlahmahasiswa.profesi !== "null"
                    ? data.jumlahmahasiswa.profesi
                    : 0}
                </h1>
                <h5
                  className="  card-title font-weight-bolder"
                  style={{ color: "#354f7a" }}
                >
                  Profesi
                </h5>
              </div>
            </div>
          </>
        );
      } else {
        profesi = (
          <>
            <div className="col-md-4">
              <div className=" d-flex flex-column align-items-center justify-content-center pt-10 pb-10 bgi-size-cover bgi-no-repeat rounded-top">
                <h1
                  className=" font-weight-bolder"
                  style={{ color: "#354f7a", fontSize: "28px" }}
                >
                  0
                </h1>
                <h5
                  className="  card-title font-weight-bolder"
                  style={{ color: "#354f7a" }}
                >
                  <del>Profesi</del>
                </h5>
              </div>
            </div>
          </>
        );
      }
      if (data.jumlahmahasiswa.sarjana !== undefined) {
        sarjana = (
          <>
            <div className="col-md-4">
              <div className=" d-flex flex-column align-items-center justify-content-center pt-10 pb-10 bgi-size-cover bgi-no-repeat rounded-top">
                <h1
                  className=" font-weight-bolder"
                  style={{ color: "#354f7a", fontSize: "28px" }}
                >
                  {data.jumlahmahasiswa.sarjana !== "null"
                    ? data.jumlahmahasiswa.sarjana
                    : 0}
                </h1>
                <h5
                  className="  card-title font-weight-bolder"
                  style={{ color: "#354f7a" }}
                >
                  Sarjana
                </h5>
              </div>
            </div>
          </>
        );
      } else {
        sarjana = (
          <>
            <div className="col-md-4">
              <div className=" d-flex flex-column align-items-center justify-content-center pt-10 pb-10 bgi-size-cover bgi-no-repeat rounded-top">
                <h1
                  className=" font-weight-bolder"
                  style={{ color: "#354f7a", fontSize: "28px" }}
                >
                  0
                </h1>
                <h5
                  className="  card-title font-weight-bolder"
                  style={{ color: "#354f7a" }}
                >
                  <del>Sarjana</del>
                </h5>
              </div>
            </div>
          </>
        );
      }
      if (data.jumlahmahasiswa["sarjana terapan"] !== undefined) {
        sarjana_terapan = (
          <>
            <div className="col-md-4">
              <div className=" d-flex flex-column align-items-center justify-content-center pt-10 pb-10 bgi-size-cover bgi-no-repeat rounded-top">
                <h1
                  className="font-weight-bolder"
                  style={{ color: "#354f7a", fontSize: "28px" }}
                >
                  {data.jumlahmahasiswa["sarjana terapan"] !== "null"
                    ? data.jumlahmahasiswa["sarjana terapan"]
                    : 0}
                </h1>
                <h5
                  className="card-title font-weight-bolder"
                  style={{ color: "#354f7a" }}
                >
                  Sarjana Terapan
                </h5>
              </div>
            </div>
          </>
        );
      } else {
        sarjana_terapan = (
          <>
            <div className="col-md-4">
              <div className=" d-flex flex-column align-items-center justify-content-center pt-10 pb-10 bgi-size-cover bgi-no-repeat rounded-top">
                <h1
                  className="font-weight-bolder"
                  style={{ color: "#354f7a", fontSize: "28px" }}
                >
                  0
                </h1>
                <h5
                  className="card-title font-weight-bolder"
                  style={{ color: "#354f7a" }}
                >
                  <del>Sarjana Terapan</del>
                </h5>
              </div>
            </div>
          </>
        );
      }
      if (data.jumlahmahasiswa.diploma !== undefined) {
        diploma = (
          <>
            <div className="col-md-4">
              <div className="d-flex flex-column align-items-center justify-content-center pt-10 pb-10 bgi-size-cover bgi-no-repeat rounded-top">
                <h1
                  className=" font-weight-bolder"
                  style={{ color: "#354f7a", fontSize: "28px" }}
                >
                  {data.jumlahmahasiswa.diploma !== "null"
                    ? data.jumlahmahasiswa.diploma
                    : 0}
                </h1>
                <h5
                  className="  card-title font-weight-bolder"
                  style={{ color: "#354f7a" }}
                >
                  Diploma
                </h5>
              </div>
            </div>
          </>
        );
      } else {
        diploma = (
          <>
            <div className="col-md-4">
              <div className="d-flex flex-column align-items-center justify-content-center pt-10 pb-10 bgi-size-cover bgi-no-repeat rounded-top">
                <h1
                  className=" font-weight-bolder"
                  style={{ color: "#354f7a", fontSize: "28px" }}
                >
                  0
                </h1>
                <h5
                  className="  card-title font-weight-bolder"
                  style={{ color: "#354f7a" }}
                >
                  <del>Diploma</del>
                </h5>
              </div>
            </div>
          </>
        );
      }
      // data.jumlahmahasiswa.magister || data.jumlahmahasiswa["magister terapan"]
      let dataWidget1 = [
        this.props.dataProfile.data.profile.jumlahmahasiswa.doktor,
        this.props.dataProfile.data.profile.jumlahmahasiswa.magister ||
          this.props.dataProfile.data.profile.jumlahmahasiswa[
            "magister terapan"
          ],
        this.props.dataProfile.data.profile.jumlahmahasiswa.profesi,
      ];
      let dataWidget2 = [
        this.props.dataProfile.data.profile.jumlahmahasiswa.sarjana,
        this.props.dataProfile.data.profile.jumlahmahasiswa["sarjana terapan"],
        this.props.dataProfile.data.profile.jumlahmahasiswa.diploma,
      ];

      let dataWidget3 = [
        this.props.dataProfile.data.profile.jumlahmahasiswa.doktor +
          this.props.dataProfile.data.profile.jumlahmahasiswa.magister ||
          this.props.dataProfile.data.profile.jumlahmahasiswa[
            "magister terapan"
          ] + this.props.dataProfile.data.profile.jumlahmahasiswa.profesi,
        this.props.dataProfile.data.profile.jumlahmahasiswa.sarjana,
        this.props.dataProfile.data.profile.jumlahmahasiswa["sarjana terapan"] +
          this.props.dataProfile.data.profile.jumlahmahasiswa.diploma,
      ];

      console.log(this.props.dataProfile.data.profile.infoprodi);

      display1 = (
        <>
          <div className="col-md-4 text-center">
            <span className="svg-icon">
              <Image
                style={{ width: "20%", marginTop: "20%" }}
                src={toAbsoluteUrl("/media/logos/mhs.png")}
              />
            </span>
            <h1
              className="font-weight-bolder"
              style={{ color: "#354f7a", fontSize: "30px" }}
            >
              {data.totalmahasiswa}
            </h1>
            <h6
              className="card-title font-weight-bolder"
              style={{ color: "#354f7a" }}
            >
              JUMLAH SELURUH MAHASISWA
            </h6>
          </div>
          <div className="col-md-8">
            <div className="row row-paddingless">
              {diploma}
              {sarjana}
              {sarjana_terapan}
              {doktor}
              {magister}
              {profesi}
            </div>
          </div>
          <div className="col-md-4 text-center">
            <Widget1 dataWidget1={dataWidget1} />
          </div>
          <div className="col-md-4 text-center">
            <Widget2 dataWidget2={dataWidget2} />
          </div>
          <div className="col-md-4 text-center">
            <Widget3 dataWidget3={dataWidget3} />
          </div>
          <div
            className="col-md-12 text-center"
            style={{ marginTop: "20px" }}
          ></div>
        </>
      );
      display2 = (
        <>
          <div
            className="col-md-12 text-center"
            style={{ marginTop: "20px", padding: "10px" }}
          >
            <h6
              className="card-title font-weight-bolder"
              style={{ color: "#354f7a" }}
            >
              DAFTAR PROGRAM STUDI
            </h6>
            <span>
              Data mahasiswa berdasarkan pelaporan aktifitas mahasiswa.<br />
              Jika tidak sesuai, Perguruan tinggi diwajibkan memperbaiki
              pelaporannya melalui aplikasi PDDikti Feeder
            </span>
          </div>
          <div
            className="col-md-12"
            style={{ padding: "1%", overflow: "auto" }}
          >
            <TableAkreditasi
              dataProdi={this.props.dataProfile.data.profile.infoprodi}
            />
          </div>
        </>
      );
    } else {
      display1 = (
        <>
          <div className="col-md-12 text-grey p-3">
            <Spinner
              as="span"
              animation="grow"
              size="sm"
              role="status"
              aria-hidden="true"
            />
            Loading ..
            <LinearProgress color="secondary" variant="query" />
          </div>
        </>
      );
      display2 = (
        <>
          <div className="col-md-12 text-grey p-3">
            <Spinner
              as="span"
              animation="grow"
              size="sm"
              role="status"
              aria-hidden="true"
            />
            Loading ..
            <LinearProgress color="secondary" variant="query" />
          </div>
        </>
      );
    }

    return (
      <>
        {/* <Card>
                            <div className="col-md-6 pt-10">
                                <Table responsive className="table table-stripped">
                                    <thead>
                                        <tr>
                                            <td style={{verticalAlign:'middle'}} className="font-weight-bold font-size-1">
                                                Nama
                                            </td>
                                            <td style={{verticalAlign:'middle'}} className="font-weight-bold font-size-1">
                                                Nomor Registrasi
                                            </td>
                                            <td style={{verticalAlign:'middle'}} className="font-weight-bold font-size-1">
                                                Kontak
                                            </td>
                                        </tr>
                                    </thead>
                                </Table>
                            </div>
                </Card> */}
        <Card>
          <div className="row row-paddingless">{display1}</div>
        </Card>
        <br />
        <Card>
          <div className="row row-paddingless">{display2}</div>
        </Card>
      </>
    );
  }
}
export default Profile1;
